import React, { useState } from 'react';
import './ImageGallery.css';

const ImageGallery = ({ title, subtitle, images }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentFilter, setCurrentFilter] = useState('all');

  const defaultImages = [
    { id: 1, src: '/assets/images/gallery/classroom.jpg', alt: 'Modern Classroom', category: 'academics' },
    { id: 2, src: '/assets/images/gallery/laboratory.jpg', alt: 'Science Laboratory', category: 'academics' },
    { id: 3, src: '/assets/images/gallery/library.jpg', alt: 'School Library', category: 'facilities' },
    { id: 4, src: '/assets/images/gallery/sports.jpg', alt: 'Sports Field', category: 'sports' },
    { id: 5, src: '/assets/images/gallery/arts.jpg', alt: 'Arts & Crafts', category: 'extracurricular' },
    { id: 6, src: '/assets/images/gallery/students.jpg', alt: 'Happy Students', category: 'life' },
    { id: 7, src: '/assets/images/gallery/assembly.jpg', alt: 'School Assembly', category: 'life' },
    { id: 8, src: '/assets/images/gallery/computer-lab.jpg', alt: 'Computer Lab', category: 'facilities' },
  ];

  const galleryImages = images || defaultImages;

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'academics', label: 'Academics' },
    { id: 'facilities', label: 'Facilities' },
    { id: 'sports', label: 'Sports' },
    { id: 'extracurricular', label: 'Activities' },
    { id: 'life', label: 'School Life' },
  ];

  const filteredImages = currentFilter === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === currentFilter);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const navigateImage = (direction) => {
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;

    if (direction === 'next') {
      newIndex = (currentIndex + 1) % filteredImages.length;
    } else {
      newIndex = currentIndex === 0 ? filteredImages.length - 1 : currentIndex - 1;
    }

    setSelectedImage(filteredImages[newIndex]);
  };

  return (
    <section className="image-gallery-section">
      <div className="container">
        {title && <h2 className="section-title">{title}</h2>}
        {subtitle && <p className="section-subtitle">{subtitle}</p>}

        {/* Category Filters */}
        <div className="gallery-filters">
          {categories.map(category => (
            <button
              key={category.id}
              className={`filter-btn ${currentFilter === category.id ? 'active' : ''}`}
              onClick={() => setCurrentFilter(category.id)}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Image Grid */}
        <div className="gallery-grid">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className="gallery-item"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => openLightbox(image)}
            >
              <div className="gallery-item__inner">
                <img src={image.src} alt={image.alt} loading="lazy" />
                <div className="gallery-item__overlay">
                  <div className="gallery-item__content">
                    <svg className="zoom-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="8" stroke="white" strokeWidth="2"/>
                      <path d="M21 21L16.65 16.65" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      <path d="M11 8V14M8 11H14" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    <p>{image.alt}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox__close" onClick={closeLightbox}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>

          <button
            className="lightbox__nav lightbox__nav--prev"
            onClick={(e) => { e.stopPropagation(); navigateImage('prev'); }}
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          <div className="lightbox__content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.src} alt={selectedImage.alt} />
            <p className="lightbox__caption">{selectedImage.alt}</p>
          </div>

          <button
            className="lightbox__nav lightbox__nav--next"
            onClick={(e) => { e.stopPropagation(); navigateImage('next'); }}
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      )}
    </section>
  );
};

export default ImageGallery;
